<template>
  <v-row row wrap style="margin-top: 0; padding: 0 12px 0 12px">
    <v-dialog
      max-width="800"
      :value="showDialog"
      persistent
      :fullscreen="$vuetify.breakpoint.smAndDown"
      @keydown.esc="toggleDialog()"
    >
      <v-card>
        <v-card-text>
          <v-container grid-list-xl>
            <v-row wrap>
              <v-textarea
                ref="editfield"
                :readonly="readonly"
                :placeholder="resx.labels.toComment"
                v-model="editValue"
              >
              </v-textarea>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="toggleDialog()">{{
            !readonly ? resx.labels.cancel : resx.labels.close
          }}</v-btn>
          <v-btn color="primary" @click="save()" v-if="!readonly">{{
            resx.labels.ok
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <a
      v-if="modeValue == 'link' && !readonly"
      @click.prevent="toggleDialog()"
      :class="{ ellipsis: this.textEllipsis }"
      >{{ getValue() || `${resx.labels.toComment}...` }}</a
    >
    <a
      v-if="modeValue == 'link' && readonly && this.getValue()"
      @click.prevent="toggleDialog()"
      :class="{ ellipsis: this.textEllipsis }"
      >{{ getValue() }}</a
    >
    <v-text-field
      v-if="modeValue == 'edit'"
      :label="label"
      readonly
      :required="required"
      @click.prevent="toggleDialog()"
      v-model="showValue"
    >
    </v-text-field>
  </v-row>
</template>

<script>
"use strict";

export default {
  name: "comments",
  props: {
    value: { type: String },
    field: { type: String },
    mode: { type: String },
    label: { type: String },
    required: { type: Boolean },
    readonly: { type: Boolean },
    textEllipsis: { type: Boolean, default: true }
  },
  data() {
    return {
      showDialog: false,
      editValue: "",
      showValue: "",
      modeValue: ""
    };
  },
  watch: {
    value(val) {
      this.showValue = val;
    }
  },
  methods: {
    toggleDialog() {
      this.showDialog = !this.showDialog;
      if (this.showDialog) {
        this.editValue = this.showValue;
        setTimeout(() => this.$refs.editfield.focus(), 300);
      }
    },
    truncatedValue() {
      const value = this.getValue();
      return value.length > 50 ? `${value.substring(0, 50)}...` : value;
    },
    save() {
      if (this.value && typeof this.value == "object") {
        this.value[this.field] = this.editValue;
        this.$emit("input", this.value);
      } else {
        this.$emit("input", this.editValue);
      }

      this.toggleDialog();
    },
    getValue() {
      return typeof this.value == "object" && this.field
        ? this.value[this.field]
        : this.value;
    }
  },
  mounted() {
    this.modeValue = this.mode ? this.mode : "link";
    this.showValue = this.value;
  }
};
</script>
